<script lang="ts">
  import { onDestroy } from "svelte";

  export let element:Element | null
  export let height: string = "100%"; // null for 100, else integer, used as percent
  export let width: string = "100%"; // null for 100, else integer, used as percent
  let parentElement:HTMLDivElement
  let currentElement:Element | null

  const ValidPxDigitsRegEx = /^\d*$/;
  function px(n: string): string {
    if (ValidPxDigitsRegEx.test(n)) {
      return n + "px";
    }
    return n;
  }

  onDestroy(() => {
    currentElement?.remove()
    currentElement = null
  })

  $ : {
    if (currentElement) {
      currentElement?.remove();
      currentElement = null;
    }
    currentElement = element
    if (currentElement) {
      parentElement?.appendChild(currentElement)
    }
  }
</script>

<div bind:this={parentElement} style="width:{px(width)};height:{px(height)}"></div>